export default "__VITE_ASSET__KjA2EQOB__"